<script>
export default {
  data() {
    return {
      checkboxModel: null,
    };
  },
};
</script>
